import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteCaregiversToConnectMutationVariables = Types.Exact<{
  careReceiverUuid: Types.Scalars['String']['input'];
  emails: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type InviteCaregiversToConnectMutation = { __typename?: 'Mutation', inviteCaregivers: number };


export const InviteCaregiversToConnectDocument = gql`
    mutation InviteCaregiversToConnect($careReceiverUuid: String!, $emails: [String!]!) {
  inviteCaregivers(careReceiverUuid: $careReceiverUuid, emails: $emails)
}
    `;
export type InviteCaregiversToConnectMutationFn = Apollo.MutationFunction<InviteCaregiversToConnectMutation, InviteCaregiversToConnectMutationVariables>;

/**
 * __useInviteCaregiversToConnectMutation__
 *
 * To run a mutation, you first call `useInviteCaregiversToConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCaregiversToConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCaregiversToConnectMutation, { data, loading, error }] = useInviteCaregiversToConnectMutation({
 *   variables: {
 *      careReceiverUuid: // value for 'careReceiverUuid'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useInviteCaregiversToConnectMutation(baseOptions?: Apollo.MutationHookOptions<InviteCaregiversToConnectMutation, InviteCaregiversToConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCaregiversToConnectMutation, InviteCaregiversToConnectMutationVariables>(InviteCaregiversToConnectDocument, options);
      }
export type InviteCaregiversToConnectMutationHookResult = ReturnType<typeof useInviteCaregiversToConnectMutation>;
export type InviteCaregiversToConnectMutationResult = Apollo.MutationResult<InviteCaregiversToConnectMutation>;
export type InviteCaregiversToConnectMutationOptions = Apollo.BaseMutationOptions<InviteCaregiversToConnectMutation, InviteCaregiversToConnectMutationVariables>;